import React from 'react';
import './OnlineIndicator.pcss';
import { Circle } from '@mm/components';

export const OnlineIndicator = () => (
  <div className="online-indicator">
    <Circle color="#6abaa4" />
    <div className="online-indicator__text">Online Now</div>
  </div>
);
